import { InvoicePdf } from './invoice-pdf.model';

export class InvoiceFile {
  invoicePdf: InvoicePdf[];

  constructor(values= {}) {
    Object.assign(this, values);

    if (this.invoicePdf) {
      for (let pdf of this.invoicePdf) {
        pdf = pdf ? new InvoicePdf(pdf) : new InvoicePdf();
      }
    }
  }
}
